import {
  Component,
  Input,
  Output,
  EventEmitter,
  OnInit,
  ChangeDetectionStrategy,
  ElementRef,
  OnDestroy
} from '@angular/core'
import { removeNgTag } from '../shared/utils'
import { SafeStyle, DomSanitizer } from '@angular/platform-browser'

@Component({
  selector: 'icos-button',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <button
      (click)="clickHandle($event)"
      [class]="
        'icos-button ' +
        (themeType ? ' icos-button--' + themeType : '') +
        (size ? ' icos-button--' + size : '') +
        ' ' +
        nativeClass
      "
      [class.is-disabled]="icosDisabled"
      [class.is-loading]="loading"
      [class.is-plain]="plain"
      [class.is-round]="round"
      [disabled]="icosDisabled"
      [type]="nativeType"
      [style]="extendStyles()"
      [autofocus]="autofocus"
    >
      <i class="icos-icon-loading" *ngIf="loading"></i>
      <i [class]="'icos-icon-' + icon" *ngIf="icon && !loading"></i>
      <ng-content></ng-content>
    </button>
  `
})
export class IcosButton implements OnInit, OnDestroy {
  @Input() set disabled(val: boolean) {
    // todo, is discarded.
    console.warn('icos Angular: (disabled) is discarded, use [icosDisabled] replace it.')
  }
  @Input() icosDisabled: boolean = false
  @Input('type') themeType: string = ''
  @Input('native-type') nativeType: string = 'button'
  @Input() size: string = ''
  @Input() icon: string = ''
  @Input() loading: boolean = false
  @Input() plain: boolean = false
  @Input() round: boolean = false
  @Input() autofocus: boolean = false
  @Input() style: string = ''
  @Input('class') nativeClass: string = ''
  @Output() click: EventEmitter<any> = new EventEmitter<any>()

  private buttonElement
  private parentElement
  constructor(private el: ElementRef, private sanitizer: DomSanitizer) {}

  clickHandle($event: Event): void {
    this.click.emit($event)
  }

  extendStyles(): SafeStyle {
    return this.sanitizer.bypassSecurityTrustStyle(this.style)
  }

  ngOnInit(): void {
    this.buttonElement = this.el.nativeElement.firstChild
    this.parentElement = this.el.nativeElement.parentElement
    removeNgTag(this.el.nativeElement)
  }

  ngOnDestroy() {
    if (this.buttonElement && this.parentElement) {
      this.parentElement.removeChild(this.buttonElement)
    }
  }
}
